import type { AuthState } from '@frontend/components/agromarket/core/access-control'
import type { LANDING_ACCESS_CONTROL_LIST } from './constants'

export enum ELandingAccessControlValue {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
  VISIBLE_AND_BLOCKED = 'VISIBLE_AND_BLOCKED',
}

export type TLandingAccessControlContext = {
  auth: AuthState
  isLoanApproved: boolean | null
}

export type TLandingAccessControlList = typeof LANDING_ACCESS_CONTROL_LIST
